import { BaseApiResponseModel } from "api/model/BaseApiResponseModel";
import { fieldPaths } from "api/apiPaths";
import client from "api/client";
import { FieldsRequestModel } from "./model/FieldsRequestModel";
import { FieldsResponseModel } from "./model/FieldsResponseModel";
import { FieldCreateRequestModel } from "./model/actions/create/FieldCreateRequestModel";
import { FieldUpdateRequestModel } from "./model/actions/update/FieldUpdateRequestModel";
import { FieldDetailResponseModel } from "./model/detail/FieldDetailResponseModel";

export interface IFieldsRepository {
  getList(
    params: FieldsRequestModel
  ): Promise<BaseApiResponseModel<FieldsResponseModel[]>>;
  getDetail(params: {
    code: string;
  }): Promise<BaseApiResponseModel<FieldDetailResponseModel>>;
  createFields(
    body: FieldCreateRequestModel
  ): Promise<BaseApiResponseModel<FieldDetailResponseModel>>;
  updateFields(
    body: FieldUpdateRequestModel
  ): Promise<BaseApiResponseModel<FieldDetailResponseModel>>;
  deleteFields(params: {
    code: string;
  }): Promise<BaseApiResponseModel<FieldDetailResponseModel>>;
}

class FieldsImpl implements IFieldsRepository {
  async getList(
    params: FieldsRequestModel
  ): Promise<BaseApiResponseModel<FieldsResponseModel[]>> {
    return await client?.get(fieldPaths?.LIST, params);
  }

  async getDetail(params: {
    code: string;
  }): Promise<BaseApiResponseModel<FieldDetailResponseModel>> {
    return await client?.get(fieldPaths?.DETAIL, params);
  }

  async updateFields(
    body: FieldUpdateRequestModel
  ): Promise<BaseApiResponseModel<FieldDetailResponseModel>> {
    return await client?.put(fieldPaths?.UPDATE, body);
  }

  async createFields(
    body: FieldCreateRequestModel
  ): Promise<BaseApiResponseModel<FieldDetailResponseModel>> {
    return await client?.post(fieldPaths?.CREATE, body);
  }

  async deleteFields(params: {
    code: string;
  }): Promise<BaseApiResponseModel<FieldDetailResponseModel>> {
    return await client?.delete(fieldPaths?.DELETE, params);
  }
}

export const defaultFieldsRepository = new FieldsImpl();
